var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApplication(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 36,
    viewBox: "0 0 31 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.76471 1.71429C3.49012 1.71429 1.64706 3.63257 1.64706 6V30C1.64706 32.3674 3.49012 34.2857 5.76471 34.2857H12.3529V36H5.76471C2.58094 36 0 33.3137 0 30V6C0 2.68629 2.58094 0 5.76471 0H22.2353C25.4191 0 28 2.68629 28 6V16.2857H26.3529V6C26.3529 3.63257 24.5099 1.71429 22.2353 1.71429H5.76471Z",
    fill: "#00CFC5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4066 21.75C26.4066 20.75 28.0284 20.75 29.0284 21.75L30.25 22.9717C31.25 23.9717 31.25 25.5934 30.25 26.5934L21.6983 35.1451C21.5716 35.2734 21.4049 35.3551 21.2266 35.3801L16.9516 35.9917C16.6916 36.0284 16.4299 35.9418 16.2432 35.7568C16.0582 35.5701 15.9716 35.3084 16.0083 35.0484L16.6199 30.7734C16.6449 30.5951 16.7266 30.4284 16.8549 30.3017L25.4066 21.75ZM23.5516 25.9617L18.23 31.2834L17.8149 34.1851L20.7166 33.7701L26.0383 28.4484L23.5516 25.9617ZM27.2166 27.2684L29.0717 25.415C29.42 25.065 29.42 24.5 29.0717 24.15L27.85 22.9283C27.5 22.58 26.935 22.58 26.585 22.9283L24.7317 24.7834L27.2166 27.2684Z",
    fill: "#00CFC5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10H8V9H20V10Z",
    fill: "#00CFC5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 18H8V17H20V18Z",
    fill: "#00CFC5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 27H8V26H14V27Z",
    fill: "#00CFC5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplication);
export default __webpack_public_path__ + "static/media/application.4dd3a82d6003dbd7fd49833f1746ea89.svg";
export { ForwardRef as ReactComponent };